import axios from 'axios';

import { toApiDateTime } from '../utils/dateUtils';

const createProject = async ({ name, status, address, startDate, endDate }) => {
  const { data: project } = await axios.post(`${process.env.REACT_APP_API_URL}/projects`, {
    name,
    status,
    address,
    startDate: toApiDateTime(startDate),
    endDate: toApiDateTime(endDate)
  });

  return { project };
}

const getProjects = async ({ status, page = 1, perPage = 10 }) => {
  const searchParams = new URLSearchParams();

  if (page) searchParams.append('page', page);
  if (perPage) searchParams.append('perPage', perPage);
  if (status) searchParams.append('status', status);

  const params = searchParams.toString();

  const url = `${process.env.REACT_APP_API_URL}/projects?${params}`;
  const { data: { projects, count, pages } } = await axios.get(url);

  return { projects, count, pages };
}

const updateProject = async ({ projectId, updateData }) => {
  const payload = {
    ...updateData
  };

  if (payload.startDate) payload.startDate = toApiDateTime(payload.startDate);
  if (payload.endDate) payload.endDate = toApiDateTime(payload.endDate);

  const url = `${process.env.REACT_APP_API_URL}/projects/${projectId}`;
  const { data: project } = await axios.put(url, payload);

  return { project };
}

const deleteProject = async (id) => {
  const { data: project } = await axios.delete(`${process.env.REACT_APP_API_URL}/projects/${id}`);

  return { project };
}

const generateQrToken = async (projectId) => {
  const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/projects/${projectId}/qr`);
  return data;
};

const invalidateQrToken = async (projectId) => {
  const { data } = await axios.delete(`${process.env.REACT_APP_API_URL}/projects/${projectId}/qr`);
  return data;
};

const projectService = {
  createProject,
  getProjects,
  updateProject,
  deleteProject,
  generateQrToken,
  invalidateQrToken
};

export default projectService;

